"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeEmails_en_us = void 0;
function backofficeEmails_en_us() {
    return {
        "backoffice.emails.title": "Email",
        "backoffice.emails.templates.name": "Template name",
        "backoffice.emails.templates.subheadline": "Create beautiful email templates in html or plain text",
        "backoffice.emails.templates.title": "Email templates",
        "backoffice.emails.templates.create": "Create email template",
        "backoffice.emails.templates.templatedeleted": "Template deleted",
        "backoffice.emails.templates.preview": "Preview",
        "backoffice.emails.templates.subject": "Subject",
        "backoffice.emails.templates.from": "From",
        "backoffice.emails.templates.content": "Content",
        "backoffice.emails.templates.notranslations": "No translations yet",
        "backoffice.emails.templates.notranslationinyourcurrentlocale": "No translation found in your current editor locale",
        "backoffice.emails.templates.sender": "Sender-address",
        "backoffice.emails.templates.hint.name": "max. 50 letters",
        "backoffice.emails.templates.hint.sender": "Sender-address that the recipient sees",
        "backoffice.emails.templates.empty.title": "No Email templates found...",
        "backoffice.emails.templates.empty.meanwhile": "In the meantime you can create your own and individual email template here.",
        "backoffice.emails.templates.empty.createtemplate": "Create new template",
        "backoffice.emails.sent.title": "Sent Emails",
        "backoffice.emails.sent.subheadline": "Complete list of all mails that were sent via this project",
        "backoffice.emails.sent.tableheaders.from": "Sender",
        "backoffice.emails.sent.tableheaders.to": "Recipient(s)",
        "backoffice.emails.sent.tableheaders.subject": "Subject",
        "backoffice.emails.sent.tableheaders.logs": "Status",
        "backoffice.emails.sent.empty.title": "No Emails sent yet...",
        "backoffice.emails.sent.empty.meanwhile": "So far, no e-mails have been sent via this system. Have you already created an email template? If not, you can do that here.",
        "backoffice.emails.sent.empty.createtemplate": "Create new template",
        "backoffice.emails.setup.title": "Setup",
        "backoffice.emails.setup.subtitle": "Configure the setup of your email providers.",
        "backoffice.emails.setup.wantmore": "Are you missing your favorite provider? Contact us, we can help!",
        "backoffice.emails.setup.providers.title": "Mail Provider",
        "backoffice.emails.setup.providers.description": "Please select and configure the mail provider you want to use for this project.",
        "backoffice.emails.setup.providers.none.title": "No Provider",
        "backoffice.emails.setup.providers.none.description": "If you don't need to send any mails, this is your choice.",
        "backoffice.emails.setup.providers.mailgun.title": "Mailgun",
        "backoffice.emails.setup.providers.mailgun.description": "Mailgun is our most used mail provider. With servers in the US and in Europe, mailgun can send mails to customers quickly. Please follow this link and create an account:",
        "backoffice.emails.setup.providers.testing.title": "Test Provider",
        "backoffice.emails.setup.providers.testing.description": "For testing purposes only! If you choose the test provider, all mails will be sent to one mail address which you can configure!",
        "backoffice.emails.setup.providers.reseller.title": "Reseller Provider",
        "backoffice.emails.setup.providers.reseller.description": "The easiest choice for sending mails. Internally, we also use Mailgun, but your mails will be send in our name. You are fully responsible for all mails that are sent via your project.",
        "backoffice.emails.setup.testing.title": "Testing",
        "backoffice.emails.setup.testing.description": "Test your current provider and send a dummy mail to your address",
        "backoffice.emails.setup.testing.sendbtn": "Send Test Mail",
        "backoffice.emails.setup.testing.email": "Test Recipient Mail Address",
        "backoffice.emails.setup.testing.sender": "Test Sender Mail Address",
        "backoffice.emailverification.backtohome": "Back to Home"
    };
}
exports.backofficeEmails_en_us = backofficeEmails_en_us;
